import { render, staticRenderFns } from "./dates.vue?vue&type=template&id=36d99aee&"
import script from "./dates.vue?vue&type=script&lang=js&"
export * from "./dates.vue?vue&type=script&lang=js&"
import style0 from "./dates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports